import React from 'react';
import styles from './step4.module.scss';
import SelectWithInput from 'components/form/selectWithInput/selectWithInput';
import DatePicker from 'components/form/date/date';
import * as Yup from 'yup';
import FormBuilder from 'components/form/builder/builder';
import * as Constants from '../constants';

const schemaShape = {
  EOPNumber: Yup.string()
    .trim()
    .matches(/^[0-9A-Za-z\s-]*$/, {
      message: 'Only letters, numbers, and spaces allowed.'
    })
    .max(
      Constants.MAX_CHARS_FOR_FIELD,
      `Please enter less than ${Constants.MAX_CHARS_FOR_FIELD} characters!`
    )
    .required('Required'),
  EOPCarrierName: Yup.string()
    .trim()
    .matches(/^[A-Za-z\s]*$/, { message: 'Only letters and spaces allowed.' })
    .max(30, 'Please enter less than 30 characters!')
    .required('Required'),
  EOPExpDate: Yup.date()
    .typeError('Invalid Date')
    .required('Required'),
  EOPLimit: Yup.number()
    .min(1, "Please type a value greater than 0")
    .required('Required', {
      message:
        'Please select an item from the select menu or specify a custom amount.'
    })
};

const Step4 = props => {

  const initialValues = {
    EOPNumber: '',
    EOPCarrierName: '',
    EOPExpDate: '',
    EOPLimit: '',
    ...props.values
  };

  const elements = [
    {
      label: 'What is the entity’s policy number?',
      placeholder: 'Enter Policy number',
      name: 'EOPNumber',
      maxLength: 20
    },
    {
      label: 'What is the name of the carrier?',
      placeholder: 'Enter carrier name',
      name: 'EOPCarrierName',
      maxLength: 30
    },
    {
      Component: DatePicker,
      label: 'What is the expiration date of the policy?',
      placeholder: 'Select Date',
      name: 'EOPExpDate'
    },
    {
      Component: SelectWithInput,
      props: {
        options: [
          { name: '$1,000,000', value: '1000000' },
          { name: '$2,000,000', value: '2000000' },
          { name: '$5,000,000', value: '5000000' },
          { name: 'Other', value: '0' }
        ],
        otherAllowed: true,
        otherValue: '0',
        otherText: 'Please enter the current limit of insurance per claim.',
        otherPlaceholder: '0',
      },
      label: 'What is the current limit of insurance per claim?',
      placeholder: 'Select Limit',
      name: 'EOPLimit'
    }
  ];

  return (
    <div className={styles.wrapper}>
      <FormBuilder
        elements={elements}
        schemaShape={schemaShape}
        initialValues={initialValues}
        onNext={props.onNext}
        updateValues={props.updateValues}
        step={props.step}
        setStep={props.setStep}
      />
    </div>
  );
};

export default Step4;
